import mutations from './erecept.mutations'
import actions from './erecept.actions'
import getters from './erecept.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
